import React from 'react';
import { ETH } from '../economics/ecoShared';

interface TornadoItem {
  name: string;
  lowChangePct: number;
  highChangePct: number;
}

export default function SensitivityTornadoChart({ items }: { items: TornadoItem[] }) {
  if (items.length === 0) return null;

  const width = 900;
  const rowHeight = 52;
  const top = 40;
  const left = 150;
  const right = 70;
  const bottom = 45;
  const height = top + items.length * rowHeight + bottom;
  const plotWidth = width - left - right;
  const centerX = left + plotWidth / 2;

  const maxAbs = Math.max(1, ...items.flatMap((item) => [Math.abs(item.lowChangePct), Math.abs(item.highChangePct)]));
  const halfWidth = plotWidth / 2 - 20;

  const scale = (value: number) => Math.abs(value) / maxAbs * halfWidth;

  return (
    <div style={{ marginTop: 14, padding: 14, background: ETH.canvasBg, border: `1px solid ${ETH.headerBorder}` }}>
      <div style={{ fontSize: 14, fontWeight: 700 }}>参数敏感性 Tornado 图</div>
      <div style={{ marginTop: 4, fontSize: 10, color: ETH.textMuted }}>左侧表示参数降低后的产量变化，右侧表示参数提高后的产量变化；条带越长表示敏感性越强</div>

      <div style={{ marginTop: 12, overflowX: 'auto' }}>
        <svg viewBox={`0 0 ${width} ${height}`} style={{ width: '100%', minWidth: 720, height }}>
          <rect x={0} y={0} width={width} height={height} fill={ETH.bg} />

          <line x1={centerX} x2={centerX} y1={top - 15} y2={height - bottom + 5} stroke={ETH.textSec} strokeWidth={1.2} />

          <text x={centerX - halfWidth} y={20} fontSize={10} fill={ETH.textMuted} textAnchor="middle">低情景</text>
          <text x={centerX} y={20} fontSize={10} fill={ETH.textMuted} textAnchor="middle">0%</text>
          <text x={centerX + halfWidth} y={20} fontSize={10} fill={ETH.textMuted} textAnchor="middle">高情景</text>

          {items.map((item, index) => {
            const y = top + index * rowHeight + 10;
            const lowWidth = scale(item.lowChangePct);
            const highWidth = scale(item.highChangePct);

            return (
              <g key={item.name}>
                <text x={left - 12} y={y + 15} textAnchor="end" fontSize={11} fill={ETH.textSec}>{item.name}</text>

                <rect x={centerX - lowWidth} y={y} width={lowWidth} height={26} fill="#888" opacity={0.75} />
                <rect x={centerX} y={y} width={highWidth} height={26} fill="#b64f35" opacity={0.85} />

                <text x={centerX - lowWidth - 6} y={y + 17} textAnchor="end" fontSize={10} fill={ETH.textMuted}>{item.lowChangePct.toFixed(2)}%</text>
                <text x={centerX + highWidth + 6} y={y + 17} textAnchor="start" fontSize={10} fill={ETH.textMuted}>+{item.highChangePct.toFixed(2)}%</text>

                <line x1={left} x2={width - right} y1={y + 35} y2={y + 35} stroke={ETH.headerBorder} />
              </g>
            );
          })}

          <text x={centerX} y={height - 12} textAnchor="middle" fontSize={10} fill={ETH.textMuted}>未来累计产气相对基准变化 / %</text>
        </svg>
      </div>
    </div>
  );
}